module.exports = __webpack_public_path__ + "img/pp.3e0bd3e3.jpg";